import PaymentNote from './PaymentNote';

export default PaymentNote;
